import axios from "axios";

// Get a service man's current Stripe onboarding/capability status
export const getStripeStatus = async (userId) => {
  const { data } = await axios.get(`stripe/status/${userId}`);
  return data;
};

// Admin-triggered: create/reuse a proper Express account and email the service man a real onboarding link
export const connectStripeAccount = async (userId) => {
  const { data } = await axios.post(`stripe/connect/${userId}`, {});
  return data;
};

// Admin-triggered, before the user exists yet: create a Stripe account + onboarding link
// so the account id can be attached to the "Add New User" form
export const createStripeInvite = async (email) => {
  const { data } = await axios.post(`stripe/create-invite`, { email });
  return data;
};
